<template>
  <div>
    <PageAllow controller="Payment" action="getPaySettings" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{ $t("Payment.hfdgPay.title") }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <ValidationObserver ref="observer">
            <v-container>
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Payment.hfdgPay.application") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" md="7">
                  {{ $t("Payment.hfdgPay.application_title") }}
                </v-col>
              </v-row>
              <!-- hfdgpay_product_id -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.hfdgPay.hfdgpay_product_id") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.hfdgPay.hfdgpay_product_id')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.hfdgpay_product_id"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'hfdgpay_product_id')
                          .concat(errors)
                      "
                    >
                      <!-- <template v-slot:message="{ key, message }">
                                <div :class="key == 0 ? 'danger--text' : ''">
                                {{ message }}
                                </div>
                            </template> -->
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- hfdgpay_huifu_id -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.hfdgPay.hfdgpay_huifu_id") + $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.hfdgPay.hfdgpay_huifu_id')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="settings.hfdgpay_huifu_id"
                      single-line
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'hfdgpay_huifu_id')
                          .concat(errors)
                      "
                    >
                      <!-- <template v-slot:message="{ key, message }">
                                <div :class="key == 0 ? 'danger--text' : ''">
                                {{ message }}
                                </div>
                            </template> -->
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- hfdgpay_acct_id -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                  $t("Payment.hfdgPay.hfdgpay_acct_id") + $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                          v-slot="{ errors }"
                          :name="$t('Payment.hfdgPay.hfdgpay_acct_id')"
                          rules="required"
                  >
                    <v-text-field
                            v-model="settings.hfdgpay_acct_id"
                            single-line
                            :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'hfdgpay_acct_id')
                          .concat(errors)
                      "
                    >
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- hfdgpay_private_key -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.hfdgPay.hfdgpay_private_key") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.hfdgPay.hfdgpay_private_key')"
                    rules="required"
                  >
                    <v-textarea
                      v-model="settings.hfdgpay_private_key"
                      outlined
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'hfdgpay_private_key')
                          .concat(errors)
                      "
                    >
                      <!-- <template v-slot:message="{ key, message }">
                                <div :class="key == 0 ? 'danger--text' : ''">
                                {{ message }}
                                </div>
                            </template> -->
                    </v-textarea>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <!-- hfdgpay_public_key -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.hfdgPay.hfdgpay_public_key") +
                    $t("Global.colon")
                  }}
                  <span class="red--text">*</span>
                </v-col>
                <v-col cols="9" md="7">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Payment.hfdgPay.hfdgpay_public_key')"
                    rules="required"
                  >
                    <v-textarea
                      v-model="settings.hfdgpay_public_key"
                      outlined
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'hfdgpay_public_key')
                          .concat(errors)
                      "
                    >
                      <!-- <template v-slot:message="{ key, message }">
                                <div :class="key == 0 ? 'danger--text' : ''">
                                {{ message }}
                                </div>
                            </template> -->
                    </v-textarea>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <!-- 预下单 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                  $t("Payment.hfdgPay.hfdg_preorder_flg") + $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="settings.hfdg_preorder_flg">
                    <v-radio :label="$t('Payment.off')" key="0" value="0" />
                    <v-radio :label="$t('Payment.on')" key="1" value="1" />
                  </v-radio-group>
                </v-col>
              </v-row>

              <!-- 启用 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("Payment.hfdgPay.hfdgpay_enable") + $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <v-radio-group row v-model="settings.hfdgpay_enable">
                    <v-radio :label="$t('Payment.off')" key="0" value="0" />
                    <v-radio :label="$t('Payment.on')" key="1" value="1" />
                  </v-radio-group>
                </v-col>
              </v-row>
            </v-container>
          </ValidationObserver>
        </v-card-text>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <!-- 保存 -->
              <v-btn color="success" block @click="save()">
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("Payment.save") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>
  </div>
</template>

<script>
import Payment from "@/api/payment";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import { mapState } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
// import Required from "@/components/plugins/Required";

export default {
  data: () => ({
    settings: {},
    serverErrors: [],
  }),
  components: {
    PageAllow,
    Breadcrumbs,
    // Required,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.fundManagement"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.payment"),
        disabled: true,
        href: "/payment",
      },
    ],
    ...mapState(["loading"]),
  },

  mounted() {
    this.getHfdgFromAPI();
  },
  methods: {
    getHfdgFromAPI() {
      Payment.fetch({
        keys: [
          "hfdgpay_product_id",
          "hfdgpay_huifu_id",
          "hfdgpay_acct_id",
          "hfdgpay_private_key",
          "hfdgpay_public_key",
          "hfdg_preorder_flg",
          "hfdgpay_enable",
        ],
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.settings = response.data.settings;
            if (
              this.settings.hfdgpay_enable == null ||
              typeof this.settings.hfdgpay_enable == "undefined" ||
              this.settings.hfdgpay_enable == undefined) {
              this.settings.hfdgpay_enable = '0';
            }
            if (
              this.settings.hfdg_preorder_flg == null ||
              typeof this.settings.hfdg_preorder_flg == "undefined" ||
              this.settings.hfdg_preorder_flg == undefined
            ) {
              this.settings.hfdg_preorder_flg = '0';
            }
          }
        }.bind(this)
      );
    },

    save() {
      this.$store.dispatch("fullscreenLoading");
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            Payment.HfdgSave(this.settings).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.$router.push("/payment");
                }
                this.$store.dispatch("fullscreenLoadingStop");
              }.bind(this)
            );
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
  },
};
</script>

<style>
</style>